module.exports = __webpack_public_path__ + "static/img/lpa_logo_small.4a29ad51.svg";